import React, { useEffect, useState } from 'react'
import ProjectLayout from '../../../../../layout/components/ProjectLayout'
import { useParams } from 'react-router-dom'
import ProjectTargetForm from '../components/ProjectTragetForm';
import projectTargetServices from '../projectTargetServices';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment';
import { CircularProgress } from '@mui/material';
import ConfirmDialog from '../../../../../components/ConfirmDialog';

function ProjectTargetListPage() {
  const { id } = useParams();
  const {getMasterLabel} = useAppData();

  const [loading,setLoadingStatus] = useState(false);
  const [targetList,setTargetList] = useState(null);
  const getTargetList = () =>{
    setLoadingStatus(false);
    projectTargetServices.getByProjectId(id).then(res=>{
      setTargetList(res.data);
    }).catch(error=>{

    }).finally(()=>{
      setLoadingStatus(false);
    })
  }

  useEffect(()=>{
    getTargetList();
  },[id])

  const remove = (id)  =>{
    projectTargetServices.remove(id).then(res=>{
      getTargetList();
    }).catch(()=>{

    })
  }


  return (
    <ProjectLayout>
      <div className='row'>
        <div className='col-md-6'><h3 className='text-primary'>Project Targets</h3></div>
        <div className='col-md-6'>
            <span className='float-end'><ProjectTargetForm projectId={id} callBack={getTargetList} /></span>
        </div>
      </div>
      <div className='row'>
        {loading &&
          <div className='text-center m-5'><CircularProgress /></div>
        }
        {targetList && !loading &&
        <table className='table'>
          <thead>
            <tr>
              <th>Target</th>
              <th>Total</th>
              <th>Unit</th>
              <th>Due Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {targetList.map(target=>
              <tr key={target.id}>
                <th>{target.title}</th>
                <td>{target.total}</td>
                <td>{getMasterLabel("product-uom", target.uom)}</td>
                <td>{moment(target.dueDate).format("LL")}</td>
                <td>
                  <ProjectTargetForm projectId={id} callBack={getTargetList} data={target} />
                  <ConfirmDialog id={target.id} confirm={remove} >Are you Sure You want to remove</ConfirmDialog>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        }
        
      </div>
    </ProjectLayout>
  )
}

export default ProjectTargetListPage